<template>
  <div ref="flickity" class="flickity-wrapper">
    <slot />
  </div>
</template>
<script>
var Flickity = require("flickity");
var ImagesLoaded = require("imagesloaded");
export default {
  props: ["options"],
  data: function() {
    return {
      flkty: null
    };
  },
  watch: {
    options: {
      handler: function() {
        this.$nextTick(() => {
          return this.init();
        });
      },
      immediate: true
    }
  },
  methods: {
    resize: function() {
      this.flkty.resize();
    },
    init: function() {
      const _this = this;
      ImagesLoaded(_this.$refs.flickity, () => {
        new Flickity(_this.$refs.flickity, {
          ..._this.options,
          on: {
            ready: function() {
              _this.flkty = this;
              _this.$refs.flickity.style.display = "block";
              this.resize();
            },
            change: function(index) {
              _this.$emit("slideChange", index);
            }
          }
        });
        _this.$emit("sliderReady", _this.flkty);
      });
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";
/*! Flickity v2.1.1
https://flickity.metafizzy.co
---------------------------------------------- */
.flickity-wrapper {
  position: relative;
  outline: none;
  display: none;
}

.flickity-enabled {
  position: relative;
}

.flickity-enabled:focus {
  outline: none;
}

.flickity-viewport {
  overflow: hidden;
  position: relative;
  height: 100%;
}

/* draggable */

.flickity-enabled.is-draggable {
  -webkit-tap-highlight-color: transparent;
  // tap-highlight-color: transparent;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.flickity-enabled.is-draggable .flickity-viewport {
  cursor: move;
  cursor: -webkit-grab;
  cursor: grab;
}

.flickity-enabled.is-draggable .flickity-viewport.is-pointer-down {
  cursor: -webkit-grabbing;
  cursor: grabbing;
}

/* ---- flickity-button ---- */

.flickity-button {
  position: absolute;
  background: none;
  border: none;
  color: #333;
}

.flickity-button:hover {
  background: none;
  cursor: pointer;
}

.flickity-button:focus {
  outline: none;
  box-shadow: 0 0 0 5px #19f;
}

.flickity-button:active {
  opacity: 0.6;
}

.flickity-button:disabled {
  opacity: 0.3;
  cursor: auto;
  /* prevent disabled button from capturing pointer up event. #716 */
  pointer-events: none;
}

.flickity-button-icon {
  fill: #fda82a;
}

/* ---- previous/next buttons ---- */

.flickity-prev-next-button {
  top: 50%;
  width: 50px;
  height: 50px;
  /* vertically center */
  transform: translateY(-50%);
  transition: transform 200ms ease;
  &:hover {
    transform: translateY(-50%) scale(1.5);
  }
}

.flickity-prev-next-button.previous {
  left: -60px;
  @media screen and (max-width: 1200px) {
    left: 0px;
  }
}
.flickity-prev-next-button.next {
  right: -60px;
  @media screen and (max-width: 1200px) {
    right: 0px;
  }
}

.flickity-prev-next-button .flickity-button-icon {
  position: absolute;
  left: 20%;
  top: 20%;
  width: 60%;
  height: 60%;
}

/* ---- page dots ---- */

.flickity-page-dots {
  position: absolute;
  width: 100%;
  bottom: -25px;
  padding: 0;
  margin: 0;
  list-style: none;
  text-align: center;
  line-height: 1;
  z-index: 1;
}

.flickity-rtl .flickity-page-dots {
  direction: rtl;
}

.flickity-page-dots .dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin: 0 8px;
  background: #333;
  border-radius: 50%;
  opacity: 0.25;
  cursor: pointer;
}

.flickity-page-dots .dot.is-selected {
  opacity: 1;
}
</style>
